import { useReactiveVar } from '@apollo/client'
import {
  activeVersionVar,
  calculatorVar,
  projectVar,
} from '../apollo/reactive-vars'
import { useCalculator } from './use-calculator'

type Hook = {
  updateDefaultCalculation: () => void
}

export function useDefaultCalculator(): Hook {
  const project = useReactiveVar(projectVar)
  const activeVersion = useReactiveVar(activeVersionVar)
  const { getCalculatedEnergies } = useCalculator()

  return {
    updateDefaultCalculation: () => {
      const calculator = getCalculatedEnergies(project, activeVersion)
      calculatorVar(calculator)
    },
  }
}
